// Standard auto-repair authorization terms shown to the customer before
// their signature is committed. Industry-standard mechanic's lien template,
// adapted for digital signature so paper-only blanks are replaced with
// shop-configurable values.
//
// Wording notes:
// - "the shop and its employees" instead of "you and/or your employees" —
//   in the HAIST UI the customer reads this on our screen, so "you" is
//   ambiguous (HAIST vs the shop). Explicit beats ambiguous.
// - Teardown reassembly window is per-shop (`shop.report_config
//   .teardown_reassembly_days`, default 30). CA BAR doesn't fix the
//   number; each shop sets their own policy.
// - "All parts removed will be discarded unless I instruct the shop
//   otherwise" — keeps the customer's verbal-override right intact without
//   the redundant trailing "Save all Parts ___" blank.

export const DEFAULT_TEARDOWN_REASSEMBLY_DAYS = 30;

export function getRepairAuthTerms(opts?: { teardownDays?: number | null }): string {
  const days = opts?.teardownDays && opts.teardownDays > 0
    ? Math.round(opts.teardownDays)
    : DEFAULT_TEARDOWN_REASSEMBLY_DAYS;
  return `Services are done at customer request. I hereby authorize the repair work shown above, along with the necessary materials, and grant the shop and its employees permission to operate the vehicle described for testing and inspection. An express mechanic's lien is hereby acknowledged on the above vehicle to secure the amount of repairs.

TEARDOWN ESTIMATE: I understand that my vehicle will be reassembled within ${days} days of the date shown above if I choose not to authorize the recommended service. All parts removed will be discarded unless I instruct the shop otherwise.

NOT RESPONSIBLE FOR LOSS OR DAMAGE TO CARS OR ARTICLES LEFT IN CARS IN CASE OF FIRE, THEFT, OR ANY OTHER CAUSE.`;
}
